import BumpGroupItem from './BumpGroupItem';

export default BumpGroupItem;
